import * as Models from "../Models";

    export interface IStatePermissionsMappingService {
        getRoleNameFromStateName: (stateName: string) => string[];
}

    export class StatePermissionsMappingService implements IStatePermissionsMappingService {
        public roleList = new Models.Auth.RoleList.RoleList();
        public uiStateList = new Models.Auth.UiStateList.UiStateList();

        getRoleNameFromStateName(stateName: string): string[] {
            if (stateName === this.uiStateList.trinityPaymentCapture) return [this.roleList.captureResidentialPayment];
            if (stateName === this.uiStateList.changePasswordForUser) return [this.roleList.changePasswordForUser];
            if (stateName === this.uiStateList.costCalculation) return [this.roleList.useEpcCalculator];
            if (stateName === this.uiStateList.creditCheck) return [this.roleList.performCreditCheck];
            if (stateName === this.uiStateList.invoices) return [this.roleList.manageResidentialInvoices, this.roleList.manageCommercialInvoices];
            if (stateName === this.uiStateList.searchUsers || stateName === this.uiStateList.editUser) {
                 return [this.roleList.manageUsers];
            }
            if (stateName === this.uiStateList.searchGroups || stateName === this.uiStateList.editGroup ||
                stateName === this.uiStateList.searchRoles || stateName === this.uiStateList.editRole ||
                stateName === this.uiStateList.searchPartner || stateName === this.uiStateList.editPartner) {
                return [this.roleList.manageUsersAdmin];
            }
            if (stateName === this.uiStateList.editIssues || stateName === this.uiStateList.createIssues || stateName === this.uiStateList.allIssues) {
                return [this.roleList.manageMyIssues];
            }
            if (stateName === this.uiStateList.manageReferenceValues) {
                return [this.roleList.manageReferenceValues];
            }
            if (stateName === this.uiStateList.manageComponents) return [this.roleList.manageComponents];
            if (stateName === this.uiStateList.manageEpcAssumedValue) return [this.roleList.manageEpcAssumedValues];
            if (stateName === this.uiStateList.updatePaymentMethod || stateName === this.uiStateList.updatePaymentMethodCustomer) return [this.roleList.updatePaymentMethod];
            if (stateName === this.uiStateList.communityPaymentCapture) return [this.roleList.captureCommunityPayment];
            if (stateName === this.uiStateList.createCustomer) return [this.roleList.createCustomer];
            if (stateName === this.uiStateList.viewCustomerDetails) return [this.roleList.viewCustomerDetails];
            if (stateName === this.uiStateList.changePasswordForUser) return [this.roleList.manageUsersAdmin];

            return [this.roleList.noRoleForState];
        }
    }
